import {
    hourlyCreateStripeInvoice,
    sendHourlyEmailToParties,
} from 'services/HourlyInvoiceService'
import { transformReminders } from 'utils/utils'

export const SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
}

export const CONTROL_SIZES = {
    [SIZES.XS]: 7,
    [SIZES.SM]: 9,
    [SIZES.MD]: 11,
    [SIZES.LG]: 14,
}

export const LAYOUT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    INLINE: 'inline',
}

export const DIRECTIONS = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left',
}

export const SELECTION_MODES = {
    YEAR: 'year',
    MONTH: 'month',
    DAY: 'day',
}

export const PICKER_VIEWS = {
    YEAR: 'year',
    MONTH: 'month',
    DATE: 'date',
}

export const STATUS = {
    DANGER: 'danger',
    SUCCESS: 'success',
    WARNING: 'warning',
}

export const STEPS_STATUS = {
    COMPLETE: 'complete',
    PENDING: 'pending',
    IN_PROGRESS: 'in-progress',
    ERROR: 'error',
}

export const PLACEMENT = {
    TOP_START: 'top-start',
    TOP_CENTER: 'top-center',
    TOP_END: 'top-end',
    BOTTOM_START: 'bottom-start',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_END: 'bottom-end',
    MIDDLE_START_TOP: 'middle-start-top',
    MIDDLE_START_BOTTOM: 'middle-start-bottom',
    MIDDLE_END_TOP: 'middle-end-top',
    MIDDLE_END_BOTTOM: 'middle-end-bottom',
}

export const DROPDOWN_ITEM_TYPE = {
    DEFAULT: 'default',
    HEADER: 'header',
    DIVIDER: 'divider',
    CUSTOM: 'custom',
}

export const DAY_DURATION = 86400000

export const bulletColors = {
    green: 'bg-green-500',
    yellow: 'bg-yellow-500',
    red: 'bg-red-500',
    grey: 'bg-yellow-500',
}

export const ODR_MEDIATOR = true

export const INVOICE_ALLOCATION_PARTY = {
    '50_PERCENT': '50_percent',
    EQUALLY_SPLIT: 'equally_split',
}

export const HOURLY_INVOICE_PARTY_SELECTION = {
    ONE: 'one',
    BOTH: 'both',
    ALL: 'all',
}

export const CASE_STATUS = {
    active: 'active',
    not_active: 'not_active',
    completed: 'completed',
    partially_completed: 'partially_completed',
    cancelled: 'cancelled',
}

export const CAR_CASE_STATUS = {
    intake: 'intake',
    awaiting_responding_party: 'awaiting_responding_party',
    awaiting_ranking: 'awaiting_ranking',
    awaiting_mediator_approval: 'awaiting_mediator_approval',
    accepted: 'accepted',
    rejected: 'rejected',
    awaiting_scheduling: 'awaiting_scheduling',
    completed: 'completed',
}

export const partyNameLoopUp = (role = 'plaintiff') => ({
    systemCoupon:
        role !== 'plaintiff' ? 'Responding Party' : 'Initiating Party',
    odrMediator: role !== 'plaintiff' ? 'Party 2' : 'Party 1',
    gscCase: 'FLA lawyer team',
    is_car_case_not_scheduled:
        role !== 'plaintiff' ? 'Responding Party' : 'Initiating Party',
})

export const GSC_CASE_TYPE = {
    GLOBAL_BOOKING_WITHOUT_INVOICE_INFO_POPULATE:
        'global_booking_without_invoice_info_populate',
    GSC_BOOKING_WITH_INVOICE_INFO_POPULATE:
        'gsc_booking_with_invoice_info_populate',
}

// const invoiceHistoryCreatePayload = {
//     case_id: 600,
//     due_date: '2025-09-14',
//     invoice_number: 'INV-2025-188',
//     items: [
//         {
//             id: 1,
//             description: 'Mediation',
//             quantity: 6,
//             rate: 400,
//             amount: 2400,
//         },
//     ],
//     mediator_id: 20,
//     selectedOption: 'both',
//     selectedParty: null,
//     send_from: {
//         name: 'Matthew Proudfoot',
//         email: 'mproudfoot@g3pmlaw.com',
//         phone: '',
//         mediator_id: 20,
//     },
//     send_to: [
//         {
//             name: 'Sally A. Ayvazian',
//             email: 'sally@sagelawgroupllp.com',
//         },
//         {
//             name: 'Mark H. Nys',
//             email: 'mnys@bwslaw.com',
//         },
//         {
//             name: 'Don’s RV Center',
//             email: 'croeb@cgdrlaw.com',
//         },
//     ],
//     status: 'sendviaemail',
//     subtotal: 2400,
// }

// step 2:
// http://localhost:5000/stripe/hourly/create/invoice
// payload
// const stripeInvoicePayload = {
//     client_id: [734, 735, 775],
//     case_id: 600,
//     invoicePaymentId: 80,
//     selectedOption: 'both',
//     reminders: {
//         first: {
//             date: '2025-09-15',
//             is_sent: false,
//         },
//         second: {
//             date: '2025-09-18',
//             is_sent: false,
//         },
//         third: {
//             date: '2025-09-22',
//             is_sent: false,
//         },
//         fourth: {
//             date: '2025-09-25',
//             is_sent: false,
//         },
//     },
//     admin_fee: '145.65',
//     is_admin_fee_added_in_line_item: false,
// }

// step3
// Request URL
// http://localhost:5000/invoice/send-hourly-invoice-email

// payload
// const wrappedDataForEmail = {
//     mediator_uuid: '74b49fc0-5d92-4a04-a52a-7f25d4441e9c',
//     case_id: 1254,
//     client_id: [1499, 1508, 1766],
//     client_information: {
//         1499: {
//             name: 'Haider',
//             email: 'hiqbal@bearplex.com',
//             address: null,
//             invoice_emails: null,
//         },
//         1508: {
//             name: 'Developer',
//             email: 'dev365@bearplex.com',
//             address: null,
//             invoice_emails: null,
//         },
//         1766: {
//             name: 'Developer 3 client',
//             email: 'dev365+party3@bearplex.com',
//             address: null,
//             invoice_emails: null,
//         },
//     },
// }

// const createInvoice = async () => {
//     try {
//         await hourlyCreateStripeInvoice(stripeInvoicePayload)

//         await sendHourlyEmailToParties(wrappedDataForEmail)
//     } catch (err) {
//         console.log('err', err)
//     }
// }

// createInvoice()
